import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { NavLink } from "react-router-dom";

import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  backLink: {
    textDecoration: "none",
    display: "inline-flex",
    marginBottom: theme.spacing(1),
  },
}));

const BackButton = ({ to, label = "Back", className }) => {
  const classes = useStyles();

  return (
    <NavLink to={to} className={clsx(classes.backLink, className)}>
      <Button
        color="primary"
        variant="text"
        size="small"
        startIcon={<ArrowBackIcon />}
      >
        {label}
      </Button>
    </NavLink>
  );
};

BackButton.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
};

export default BackButton;
